module.exports = {
  locales: ['en', 'fr'],
  defaultLocale: 'en',
  id: 6,
  logo: {
    sources: [
      {
        media: '(max-width: 1024px)',
        srcSet: `${process.env.PUBLIC_PREFIX}/svg/tenants/6/feuvert_bparts_logo_mobile.svg`,
      },
    ],
    img: `${process.env.PUBLIC_PREFIX}/svg/tenants/6/feuvert_bparts_logo.svg`,
  },
  font: {
    name: 'Nunito Sans',
    url: 'https://fonts.googleapis.com/css?family=Nunito+Sans:300,600&display=swap',
  },
};
